import React from 'react';
import { FDBox, FDStack } from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  OnboardingAssetsAndLiabilitiesAddContent,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingAssetsAndLiabilitiesAdd/OnboardingAssetsAndLiabilitiesAddContent/OnboardingAssetsAndLiabilitiesAddContent';
import AssetsAndLiabilitiesHeader
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/AssetsAndLiabilitiesPartnerQuestion/AssetsAndLiabilitiesHeader';
import SurveyStepFooter from 'Views/Onboarding/Pages/Survey/SurveyStep/SurveyStepFooter';
import fr from 'facet-rest';
import MissingInformationConfirmationDialog
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingRecurringExpenses/MissingInformationConfirmationDialog';
import { displayErrorMessageWithChecks } from 'Context/SnackbarContext/utils';
import { useSurveyContext } from 'Views/Onboarding/Pages/Survey/SurveyContext';
import { useSnackbarContext } from 'Context/SnackbarContext';

export const isAssetsAndLiabilitiesContinueButtonDisabled = (institutionGroups) => {
  if (institutionGroups.length === 0) {
    return true;
  }

  return institutionGroups.some(groupResource => {
    const items = groupResource.attr('items');
    return items.resources().list().some(itemResource => {
      return itemResource.attr('isMissingInformation') === true;
    });
  });
};

const OnboardingAssetsAndLiabilitiesAddLayout = () => {
  const { setOnboardingStepCollection } = useSurveyContext();
  const { displayErrorMessage } = useSnackbarContext();
  const [showConfirmation, setShowConfirmation] = React.useState(false);

  const {
    resource,
    onSubmit: onSubmitMetaForm,
  } = useMetaLayoutContext();

  const handleSubmitFromConfirmation = async () => {
    try {
      const newOnboardingCollection = await onSubmitMetaForm();
      setOnboardingStepCollection(newOnboardingCollection);
    } catch (err) {
      displayErrorMessageWithChecks(err, displayErrorMessage, 'Failed to submit');
    }
  };

  const handleSubmit = async () => {
    try {
      const [tmpResource] = await resource.link('self').get();
      tmpResource.withRelationship(fr.relationships.missingInformationConfirmation.name, () => {
        setShowConfirmation(true);
      }, async () => {
        await handleSubmitFromConfirmation();
      });
    } catch (err) {
      displayErrorMessageWithChecks(err, displayErrorMessage, 'Failed to submit');
    }
  };

  const isContinueButtonDisabled = isAssetsAndLiabilitiesContinueButtonDisabled(resource.attr('institutionGroups').resources().list());
  return (
    <FDBox>
      <FDStack direction={'column'} spacing={4}>
        <AssetsAndLiabilitiesHeader resource={resource} />
        <OnboardingAssetsAndLiabilitiesAddContent resource={resource} />
      </FDStack>
      <SurveyStepFooter
        onSubmit={handleSubmit}
        NextButtonProps={{
          disabled: isContinueButtonDisabled,
        }}
      />
      <MissingInformationConfirmationDialog
        relationship={resource.relationship(fr.relationships.missingInformationConfirmation.name)}
        isOpen={showConfirmation}
        setOpen={setShowConfirmation}
        handleNext={handleSubmitFromConfirmation}
      />
    </FDBox>
  );
};

OnboardingAssetsAndLiabilitiesAddLayout.defaultProps = {};

OnboardingAssetsAndLiabilitiesAddLayout.propTypes = {};

export { OnboardingAssetsAndLiabilitiesAddLayout };
